// new code login with email password
import { useState } from "react";
import axios from "axios";
// import "../../stylingcss/login.css";
import "../../css/login.css";
import { Navigate, useNavigate } from "react-router-dom";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";

export const AdminLogin = () => {
  const [user, setUser] = useState({ email: "", password: "", name: "" });
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPassword, setOldPassword] = useState(""); // Old password for verification
  const [showPassword, setShowPassword] = useState(false); // Toggle password visibility
  const [activeForm, setActiveForm] = useState("login"); // Track active form
  const navigate = useNavigate(``);
  const handleSignupChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleLoginChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://api.bgmhotel.com/hotelAdminSignup",
        {
          name: user.username,
          email: user.email,
        }
      );
      alert(response.data.message);
    } catch (error) {
      alert(error.response?.data?.message || "Signup failed.");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://api.bgmhotel.com/hotelAdminLogin",
        loginData
      );
      alert(response.data.message);
      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        //   const username = user.email.split("@")[0]; // Replace with response.data.username if provided
        const username = response.data.token; // Replace with response.data.username if provided
        navigate(`/${username}/hoteladmin`);
      }
    } catch (error) {
      alert(error.response?.data?.message || "Login failed.");
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      alert("New passwords do not match.");
      return;
    }
    try {
      const response = await axios.post(
        "https://api.bgmhotel.com/changePassword",
        {
          email: loginData.email,
          oldPassword,
          newPassword,
        }
      );
      alert(response.data.message);
      setActiveForm("login"); // Return to login after successful password change
    } catch (error) {
      alert(error.response?.data?.message || "Password change failed.");
    }
  };
  return (
    <div className="loginscreen">
      <div className="main">
        <input type="checkbox" id="chk" aria-hidden="false" />

        <div className="signup container">
          <form onSubmit={handleSignup}>
            <label htmlFor="chk" aria-hidden="true">
              Sign up
            </label>
            <input
              className="form-control col-md-6 my-2"
              type="text"
              name="username"
              placeholder="User name"
              value={user.username}
              onChange={handleSignupChange}
              required
              disabled
            />
            <input
              className="form-control col-md-6 my-2"
              type="email"
              name="email"
              placeholder="Email"
              value={user.email}
              onChange={handleSignupChange}
              required
              disabled
            />
            <button type="submit" disabled>
              Sign up
            </button>
          </form>
        </div>

        <div className="login container">
          <label
            htmlFor="chk"
            aria-hidden="true"
            style={{ textWrap: "nowrap" }}
            className="pt-2"
          >
            {activeForm}
          </label>
          {activeForm === "login" && (
            <form onSubmit={handleLogin}>
              <input
                className="form-control col-md-6 my-2"
                type="email"
                name="email"
                placeholder="Email"
                value={loginData.email}
                onChange={handleLoginChange}
                required
              />
              <div className="password-container">
                <div className="input-group mb-3">
                  <input
                    className="form-control col-md-6"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    value={loginData.password}
                    onChange={handleLoginChange}
                    required
                  />
                  <div className="input-group-prepend">
                    <span
                      //   className="view-password-icon"
                      className="input-group-text"
                      id="basic-addon1"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <FiEye size={24} />
                      ) : (
                        <FiEyeOff size={24} />
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <button type="submit" className="">
                Login
              </button>
            </form>
          )}
          {/* Change Password Form */}
          {activeForm === "Change Password" && (
            <form onSubmit={handlePasswordChange}>
              <input
                className="form-control col-md-6 my-2"
                type="email"
                name="email"
                placeholder="Email"
                value={loginData.email}
                onChange={handleLoginChange}
                required
              />
              <input
                className="form-control col-md-6 my-2"
                type="password"
                placeholder="Old Password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
              />
              <input
                className="form-control col-md-6 my-2"
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <input
                className="form-control col-md-6 my-2"
                type="password"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <button type="submit" className="">
                Change Password
              </button>
            </form>
          )}
          <div className="col-12">
            <hr />
            <div className="button-group">
              <div className="row">
                {activeForm !== "login" && (
                  <button
                    onClick={() => setActiveForm("login")}
                    className={` ${activeForm === "login" ? "active" : ""}`}
                  >
                    Login
                  </button>
                )}
                {activeForm !== "Change Password" && (
                  <button
                    onClick={() => setActiveForm("Change Password")}
                    className={` ${
                      activeForm === "Change Password" ? "active" : ""
                    }`}
                  >
                    Change Password
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
